var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-select',{attrs:{"list":_vm.filteredConditions,"button-title":_vm.$t('create_condition_button_create_title'),"popup-title-key":'create_condition_create_popup_title',"disabled":_vm.disabled,"tabs":{
    show: true,
    tabs: _vm.tabs,
    currentTab: _vm.currentTab,
    title: this.$t('field_trigger_condition_zone')
  }},on:{"tab-click":_vm.sortByTab,"after-modal-close":_vm.resetTabsState,"select":_vm.selectCondition}})}
var staticRenderFns = []

export { render, staticRenderFns }